import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

export interface ProjectClosure {
  title: string;
  process: string;
  forms: string;
  actions: string;
  reporting: string;
  deliverables: string;
}
@Component({
  selector: 'app-project-closure-list',
  
  templateUrl: './project-closure-list.component.html',
  styleUrl: './project-closure-list.component.css'
})
export class ProjectClosureListComponent  {
  dataSource = new MatTableDataSource<ProjectClosure>([]);
  displayedColumns: string[] = ['title', 'process', 'forms', 'actions', 'reporting', 'deliverables'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dummyData: ProjectClosure[] = [
  {
    title: 'Project Closure',
    process: 'Final documentation, Closure process',
    forms: 'Project closure form, Final documentation form',
    actions: 'User completes final documentation, closes project',
    reporting: 'Comprehensive reporting, Data archival',
    deliverables: 'Completion of all project deliverables'
  },
  {
    title: 'Project Alpha Closure',
    process: 'Prepare closure checklist, finalize reports',
    forms: 'Alpha closure form, Release note',
    actions: 'Team finalizes and submits closure docs',
    reporting: 'Project summary, financial report archive',
    deliverables: 'Delivery of final product and documentation'
  },
  {
    title: 'Project Beta Closure',
    process: 'Conduct closure meeting, gather feedback',
    forms: 'Beta closure form, Feedback survey',
    actions: 'User reviews feedback and closes project',
    reporting: 'Closure presentation, Feedback report',
    deliverables: 'Final handover to client'
  }
];

  constructor(private fb: FormBuilder) {
   
  }

  // ngOnInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }
  ngOnInit() {
  this.dataSource = new MatTableDataSource<ProjectClosure>(this.dummyData);
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
}



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}